import React from 'react';

import { CircleLoading } from '../../Loading';

const SelectLoadingIndicator = () => <CircleLoading height={12} size={12} thickness={4} width={24} />;

export default SelectLoadingIndicator;
